import React, { useState, useEffect } from 'react'
import GetAutoSuggestionsForTags from '../../Services/Queries/GetAutoSuggestionsForTags'

function GalleryInput(props) {
  const {
    selectImages,
    imagePreviews,
    disableInput,
    imageTitleChange,
    selectedImageTitles,
    setImagePreviews,
    pushImagesToArray,
    ImageType,
    updateTags,
    imageTags,
  } = props

  const [suggestedTags, setSuggestedTags] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const [activeIndex, setActiveIndex] = useState(null)

  const handleTagCheckboxChange = (tag, checked, index) => {
    const currentTags = imageTags[index] || []
    if (checked) {
      updateTags(index, [...currentTags, tag])
    } else {
      updateTags(
        index,
        currentTags.filter(t => t !== tag),
      )
    }
  }

  const fetchSuggestions = async () => {
    const input = {
      mode: 'TFIDB',
      contentType: 'personGalleryImages',
      search: searchInput,
      from: 0,
      limit: 1000,
    }

    try {
      const suggestedTags = await GetAutoSuggestionsForTags(input)
      const sortedTags = suggestedTags.items
        ? suggestedTags.items.sort((a, b) => a.tagURL.localeCompare(b.tagURL))
        : []
      setSuggestedTags(sortedTags)
    } catch (error) {
      console.error('Error fetching suggestions:', error)
    }
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchSuggestions()
    }, 300)

    return () => clearTimeout(timeoutId)
  }, [searchInput])

  return (
    <div className='container'>
      <input
        type='file'
        className='form-control'
        accept='image/*'
        placeholder='Please select gallery images'
        onChange={selectImages}
        multiple
        style={{ color: imagePreviews.length > 0 ? 'black' : 'transparent' }}
        disabled={disableInput}
      />
      {/* <label>Image Titles:</label> */}

      {imagePreviews.map((preview, index) => (
        <div key={index} className='mt-3'>
          <label>Image Title:</label>
          <input
            type='text'
            placeholder='Please enter image title'
            className='form-control'
            onChange={e => imageTitleChange(e, index)}
            value={selectedImageTitles[index] || ''}
            disabled={disableInput}
          />
          <div style={{ position: 'relative', left: '165px', top: '50px' }}>
            {/* Remove button for previewed image */}
            {
              <button
                className='btn btn-danger'
                type='button'
                onClick={() => setImagePreviews(prev => prev.filter((_, i) => i !== index))}
                disabled={disableInput}
              >
                X
              </button>
            }
          </div>
          <div className='d-flex gap-3 mt-3'>
            <img
              src={preview}
              className='img-fluid posterimage'
              alt='poster-url'
              width='200'
              height='200'
            />
            <div style={{ position: 'relative', top: '80px' }}>
              <button
                className='btn btn-primary'
                type='button'
                onClick={() => pushImagesToArray(index)}
                disabled={!selectedImageTitles[index] || !preview || disableInput}
              >
                OK
              </button>
            </div>
            {/* <div>
              <button
                className='btn btn-danger'
                type='button'
                onClick={() => setImagePreviews(prev => prev.filter((_, i) => i !== index))}
                disabled={disableInput}
              >
                X
              </button>
            </div> */}
          </div>
          {ImageType === 'person' && (
            <div className='mt-3'>
              <label className='mb-2 d-block'>Category:</label>
              <div
                className='border border-dark p-3 rounded'
                style={{
                  maxHeight: '300px',
                  overflowY: 'auto',
                  display: 'grid',
                  maxWidth: '300px',
                  gap: '1rem',
                }}
              >
                <input
                  type='text'
                  placeholder='Search Category...'
                  className='form-control mb-3'
                  onChange={e => {
                    setSearchInput(e.target.value)
                    setActiveIndex(index)
                  }}
                  value={activeIndex === index ? searchInput : ''}
                  disabled={disableInput}
                />
                {suggestedTags.map((tag, tagIndex) => (
                  <div key={tagIndex} className='form-check'>
                    <input
                      type='checkbox'
                      id={`tag-${index}-${tagIndex}`}
                      className='form-check-input'
                      onChange={e => handleTagCheckboxChange(tag.tagURL, e.target.checked, index)}
                      checked={(imageTags[index] || []).includes(tag.tagURL)}
                      disabled={disableInput}
                    />
                    <label htmlFor={`tag-${index}-${tagIndex}`} className='form-check-label ml-2'>
                      {tag.tagURL}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default GalleryInput
